import { closeOtherDropdowns } from 'common-front/src/designSystem/components/dropdown/dropdown';
import { DropdownEllipsis } from 'common-front/src/designSystem/components/dropdown/dropdownEllipsis';
import { ItemIcon } from 'common-front/src/designSystem/components/dropdown/item';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { WorkflowState, WorkflowsWorkflowFragment } from 'common/src/generated/types';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';
import * as React from 'react';
import {
    useWorkflowDuplicateMutation,
    useWorkflowExecuteMutation
} from '../../generated/graphqlHooks';
import { DeleteWorkflow } from '../delete/deleteWorkflow';

interface IWorkflowRowDropdownProps {
    workflow: WorkflowsWorkflowFragment;

    reload(): void;
}

export const WorkflowRowDropdown = (props: IWorkflowRowDropdownProps) => {
    const {
        history,
        translate,
        params: { organizationId, eventId }
    } = useHeavent();
    const { mutate: workflowDuplicate } = useWorkflowDuplicateMutation();
    const { mutate: workflowExecute } = useWorkflowExecuteMutation();
    const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);

    return (
        <>
            <DropdownEllipsis>
                <ItemIcon
                    icon="play"
                    isDisabled={props.workflow.state === WorkflowState.Paused}
                    onClick={async () => {
                        await workflowExecute({
                            eventId,
                            workflowId: props.workflow.id
                        });

                        props.reload();
                    }}
                >
                    {translate('ex_cuter_54158')}
                </ItemIcon>

                <ItemIcon
                    icon="pen"
                    to={WorkflowsPaths.UPDATE({
                        organizationId,
                        eventId,
                        workflowId: props.workflow.id
                    })}
                >
                    {translate('_diter_62574')}
                </ItemIcon>

                <ItemIcon
                    icon="clone"
                    onClick={async () => {
                        const {
                            workflowDuplicate: { id: newWorkflowId }
                        } = await workflowDuplicate({
                            eventId,
                            workflowId: props.workflow.id
                        });

                        history.push(
                            WorkflowsPaths.UPDATE({
                                organizationId,
                                eventId,
                                workflowId: newWorkflowId
                            })
                        );
                    }}
                >
                    {translate('dupliquer_28256')}
                </ItemIcon>

                <ItemIcon
                    color="red"
                    icon="trash-can"
                    onClick={(e) => {
                        setIsDeleteOpen(true);
                        closeOtherDropdowns(e.target);
                    }}
                >
                    {translate('supprimer_43083')}
                </ItemIcon>
            </DropdownEllipsis>

            {isDeleteOpen && (
                <DeleteWorkflow
                    workflow={props.workflow}
                    onClose={() => {
                        setIsDeleteOpen(false);
                    }}
                    onSuccess={props.reload}
                />
            )}
        </>
    );
};
